/**
 * かんたん検索: メタは filter.p.m.filter.*。各ステップはラジオ単一選択。
 * 各ステップはアコーディオン表示（トイザらス toy-finder 風）。現在地のみパネルを開く。
 */
(function () {
  /** DOMContentLoaded を待たずに実行できるよう、読み込み状態に応じてコールバックを登録する */
  function domReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  /**
   * チェック済みラジオと singleParams 設定から検索 URL を組み立てる（セクション非依存の共通処理）
   * @param {object} parts
   * @param {string} parts.searchBasePath 例: /search
   * @param {object} parts.defaultQuery 例: { q: '*', type: 'product' }
   * @param {Set<string>} parts.singleParams 同一キーは最後の値のみにする param 名の集合
   * @param {function(): HTMLInputElement[]} parts.getFilterInputs チェック済みの filter 用 input を返す
   */
  function buildSearchUrlFromParts(parts) {
    var url = new URL(parts.searchBasePath, window.location.origin);
    Object.entries(parts.defaultQuery || {}).forEach(function (kv) {
      url.searchParams.set(kv[0], kv[1]);
    });

    var inputs = parts.getFilterInputs();
    var collected = new Map();

    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (!(input instanceof HTMLInputElement)) continue;
      if (!input.checked) continue;
      var param = input.dataset.filterParam;
      var value = input.value;
      if (!param || !value) continue;
      if (!collected.has(param)) collected.set(param, []);
      collected.get(param).push(value);
    }

    var singleParams = parts.singleParams;
    collected.forEach(function (values, param) {
      if (singleParams.has(param)) {
        url.searchParams.set(param, values[values.length - 1]);
      } else {
        for (var k = 0; k < values.length; k++) {
          url.searchParams.append(param, values[k]);
        }
      }
    });

    return url;
  }

  /**
   * ラベル文字列を正規化
   * @param {string} text
   */
  function easyNormalizeText(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  /**
   * ステップ内の選択内容を要約文にする
   * @param {Element|null} stepEl .c-easy-search__step
   */
  function easyStepSummaryText(stepEl) {
    if (!stepEl) return '';
    var checked = stepEl.querySelector('input[type="radio"][data-filter-param]:checked');
    if (checked instanceof HTMLInputElement) {
      var id = checked.getAttribute('id');
      if (id) {
        var label = stepEl.querySelector('label[for="' + CSS.escape(id) + '"]');
        if (label) return easyNormalizeText(label.textContent);
      }
      var wrapLabel = checked.closest('label');
      if (wrapLabel) return easyNormalizeText(wrapLabel.textContent);
      return easyNormalizeText(checked.value);
    }
    return '';
  }

  /**
   * アコーディオン見出しに選択済みラベルを表示
   * @param {Element|null} root .c-easy-search[data-easy-search-root]
   */
  function easyUpdateStepSummaries(root) {
    if (!root) return;
    root.querySelectorAll('.c-easy-search__step').forEach(function (stepEl) {
      var sumEl = stepEl.querySelector('[data-easy-search-step-summary]');
      if (!sumEl) return;
      var text = easyStepSummaryText(stepEl);
      if (text) {
        sumEl.textContent = text;
        sumEl.hidden = false;
      } else {
        sumEl.textContent = '';
        sumEl.hidden = true;
      }
    });
  }

  /**
   * そのステップでラジオが1つ選ばれているか
   * @param {Element|null} stepEl .c-easy-search__step
   */
  function easyStepChoiceIsComplete(stepEl) {
    if (!stepEl) return true;
    var radios = stepEl.querySelectorAll('input[type="radio"][data-filter-param]');
    if (!radios.length) return true;
    for (var r = 0; r < radios.length; r++) {
      if (radios[r].checked) return true;
    }
    return false;
  }

  /**
   * 各ステップの「次に進む」ボタンを、選択が完了するまで disabled にする
   * @param {Element|null} root .c-easy-search[data-easy-search-root]
   */
  function easySyncNextButtons(root) {
    if (!root) return;
    root.querySelectorAll('.c-easy-search__step').forEach(function (stepEl) {
      var btn = stepEl.querySelector('[data-easy-search-action="next"]');
      if (!(btn instanceof HTMLButtonElement)) return;
      btn.disabled = !easyStepChoiceIsComplete(stepEl);
    });
  }

  /**
   * かんたん検索セクション 1 つ分のイベント・URL 組み立てを初期化する
   * @param {Element} root
   * @param {object} config #c-easy-search-config-* の JSON
   */
  function initEasySearch(root, config) {
    if (root.dataset.easySearchInited === '1') return;
    root.dataset.easySearchInited = '1';

    var singleParamKeys = Array.isArray(config.singleParamKeys) ? config.singleParamKeys : [];
    var singleParams = new Set(singleParamKeys);
    var searchBasePath = config.searchBasePath || '/search';
    var defaultQuery = config.defaultQuery || { q: '*', type: 'product' };

    /** セクション内でチェック済みの filter 用ラジオをすべて返す */
    function getFilterRadios() {
      return Array.from(root.querySelectorAll('input[type="radio"][data-filter-param]')).filter(function (inp) {
        return inp instanceof HTMLInputElement && inp.checked;
      });
    }

    /** チェック済みラジオを反映した検索 URL */
    function buildMetaFilterUrl() {
      return buildSearchUrlFromParts({
        searchBasePath: searchBasePath,
        defaultQuery: defaultQuery,
        singleParams: singleParams,
        getFilterInputs: getFilterRadios,
      });
    }

    /** 検索ページへ遷移する */
    function goSearch() {
      var url = buildMetaFilterUrl();
      window.location.href = url.pathname + url.search;
    }

    /** 指定ステップ内のラジオをすべて未選択にする（スキップ時） */
    function clearRadiosInStep(stepEl) {
      if (!stepEl) return;
      stepEl.querySelectorAll('input[type="radio"]').forEach(function (inp) {
        inp.checked = false;
      });
    }

    /** data-step が一致する .c-easy-search__step を返す */
    function getStep(stepNum) {
      return root.querySelector('.c-easy-search__step[data-step="' + stepNum + '"]');
    }

    /** フロー全体のステップ数 */
    function getTotalSteps() {
      return root.querySelectorAll('.c-easy-search__step').length;
    }

    /** 現在アクティブなステップ番号（1 始まり） */
    function getCurrentStep() {
      var active = root.querySelector('.c-easy-search__step.is-active');
      if (!active) return 1;
      return parseInt(active.getAttribute('data-step') || '1', 10);
    }

    /** アニメーションを有効にするか（ユーザー設定で無効化） */
    function easyMotionEnabled() {
      return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    /**
     * 進行演出用クラスを一定時間後に外す
     * @param {Element} el
     * @param {string} className
     * @param {number} ms
     */
    function easyTempClass(el, className, ms) {
      if (!el || !easyMotionEnabled()) return;
      el.classList.add(className);
      window.setTimeout(function () {
        el.classList.remove(className);
      }, ms);
    }

    /**
     * アコーディオン: n 番目を開き、それ以前は完了・それ以降は未完了として閉じる
     * @param {number} n 1 始まり
     * @param {{ animateForward?: boolean }} [options] 「次に進む」等で先に進むとき true
     */
    function showStep(n, options) {
      options = options || {};
      var total = getTotalSteps();
      var target = Math.max(1, Math.min(total, n));
      var previous = getCurrentStep();
      var animateForward = !!options.animateForward && target > previous && easyMotionEnabled();

      root.querySelectorAll('.c-easy-search__step').forEach(function (el) {
        var sn = parseInt(el.getAttribute('data-step') || '0', 10);
        var isActive = sn === target;
        var isComplete = sn < target;

        el.classList.remove('is-entering');
        el.classList.toggle('is-active', isActive);
        el.classList.toggle('is-complete', isComplete);
        el.removeAttribute('hidden');

        var trigger = el.querySelector('[data-easy-search-accordion-trigger]');
        var panel = el.querySelector('.c-easy-search__accordion-panel');
        if (trigger) {
          trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          trigger.disabled = !isActive && !isComplete;
        }
        if (panel) panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      var stepEl = getStep(target);
      if (stepEl) {
        /* toy-finder 同様: ページはスクロールせず、1の見出し位置を保ったまま2・3のパネルだけ下に開く */
        if (animateForward) {
          easyTempClass(stepEl, 'is-entering', 600);
        }

        var panel = stepEl.querySelector('.c-easy-search__accordion-panel');
        if (panel) {
          var focusTarget = panel.querySelector(
            'input[type="radio"][data-filter-param], button[data-easy-search-action]'
          );
          if (focusTarget instanceof HTMLElement) {
            try {
              focusTarget.focus({ preventScroll: true });
            } catch (_) {}
          }
        }
      }

      easyUpdateStepSummaries(root);
      easySyncNextButtons(root);
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!(t instanceof HTMLInputElement)) return;
      if (t.type === 'radio' && t.dataset.filterParam) {
        easyUpdateStepSummaries(root);
        easySyncNextButtons(root);
      }
    });

    showStep(1);

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;

      var accordionTrigger = t.closest('[data-easy-search-accordion-trigger]');
      if (accordionTrigger) {
        var stepFromTrigger = accordionTrigger.closest('.c-easy-search__step');
        if (!stepFromTrigger) return;
        var sn = parseInt(stepFromTrigger.getAttribute('data-step') || '0', 10);
        var current = getCurrentStep();
        if (sn > current && !stepFromTrigger.classList.contains('is-complete')) return;
        if (sn !== current) showStep(sn);
        return;
      }

      var next = t.closest('[data-easy-search-action="next"]');
      var back = t.closest('[data-easy-search-action="back"]');
      var skip = t.closest('[data-easy-search-action="skip"]');
      var submit = t.closest('[data-easy-search-action="submit"]');

      var totalSteps = getTotalSteps();

      if (next) {
        var step = parseInt(next.getAttribute('data-from-step') || '1', 10);
        if (step < totalSteps) {
          easyTempClass(root, 'is-advancing', 450);
          showStep(step + 1, { animateForward: true });
        }
        return;
      }

      if (back) {
        var bs = parseInt(back.getAttribute('data-from-step') || '1', 10);
        if (bs > 1) showStep(bs - 1);
        return;
      }

      if (skip) {
        var ss = parseInt(skip.getAttribute('data-from-step') || '1', 10);
        clearRadiosInStep(getStep(ss));
        easyUpdateStepSummaries(root);
        easySyncNextButtons(root);
        if (ss < totalSteps) {
          showStep(ss + 1, { animateForward: true });
        } else {
          goSearch();
        }
        return;
      }

      if (submit) {
        e.preventDefault();
        goSearch();
      }
    });
  }

  /** ページ上の各かんたん検索セクションに対し設定 JSON を読み initEasySearch を実行 */
  domReady(function () {
    document.querySelectorAll('.c-easy-search[data-easy-search-root]').forEach(function (root) {
      var sid = root.getAttribute('data-easy-search-section-id');
      if (!sid) return;
      var el = document.getElementById('c-easy-search-config-' + sid);
      if (!el) return;
      try {
        var config = JSON.parse(el.textContent || '{}');
        initEasySearch(root, config);
      } catch (_) {}
    });
  });
})();
